<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">Product Activation</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/dash">Home</router-link></li>
                            <li class="breadcrumb-item active">Payment</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content-header -->

            <section class="content payment">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card card_payment">
                                <div class="card-body">
                                    <h5 class="depo">Deposit Broker</h5>
                                    <h3 class="money">{{transaction.deposit_amount}}</h3>
                                </div>
                            </div>

                            <div class="card card_item">
                                <div class="card-header">
                                    <h5 class="">Item</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-4">
                                            <figure class="item_image">
                                                <img :src="transaction.product_image" alt="">
                                            </figure>
                                        </div>
                                        <div class="col-8">
                                            <h5 class="item_name">{{transaction.product_name}}</h5>
                                            <p class="item_title">Product Type :</p>
                                            <p class="item_value" v-if="transaction.product_type == 'FUND_MANAGER'">
                                                FUND MANAGER
                                            </p>
                                            <p class="item_value" v-else>
                                                {{transaction.product_type ? transaction.product_type : '-'}}
                                            </p>
                                            <p class="item_title">Broker :</p>
                                            <p class="item_value">
                                                {{brokerName}}
                                            </p>
                                            <p class="item_title">Total Payment :</p>
                                            <h5 class="item_price">
                                                {{transaction.payment_amount}}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="button">
                                <button type="submit" class="btn btn_red" data-toggle="modal" data-target="#agreement">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 38 38">
                                        <g id="icon_check" transform="translate(-798 -389)">
                                            <circle id="Ellipse_56" data-name="Ellipse 56" cx="19" cy="19" r="19" transform="translate(798 389)" fill="#ffffff" opacity="0.5"/>
                                            <path id="Icon_awesome-check" data-name="Icon awesome-check" d="M6.588,18.758l-6.3-6.3a.97.97,0,0,1,0-1.372L1.656,9.711a.97.97,0,0,1,1.372,0l4.247,4.247,9.1-9.1a.97.97,0,0,1,1.372,0l1.372,1.372a.97.97,0,0,1,0,1.372L7.96,18.758A.97.97,0,0,1,6.588,18.758Z" transform="translate(807 396.423)" fill="#ffffff"/>
                                        </g>
                                    </svg>
                                    Activate
                                </button>
                            </div>
                        </div>
                        
                        <div class="modal modal_agree fade" id="agreement" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-body">
                                        <div class="text-center">
                                            <h3 class="title">Product Agreement</h3>
                                            <p>Please read the following agreement carefully!</p>
                                        </div>
                                        <div v-if="success" class="alert alert-success" role="alert">
                                            {{success}}
                                        </div>
                                        <div v-if="error" class="alert alert-danger" role="alert">
                                            {{error}}
                                        </div>
                                        <div class="box-agree" id="box-agree">
                                            <p class="text">
                                                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Praesentium deserunt est nihil molestiae, sequi ex asperiores. Nisi vel vero iste quisquam, saepe delectus, quae neque minima optio ullam, nulla rerum.
                                            </p>
                                            <p class="text">
                                                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Praesentium deserunt est nihil molestiae, sequi ex asperiores. Nisi vel vero iste quisquam, saepe delectus, quae neque minima optio ullam, nulla rerum.
                                            </p>
                                            <p class="text">
                                                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Praesentium deserunt est nihil molestiae, sequi ex asperiores. Nisi vel vero iste quisquam, saepe delectus, quae neque minima optio ullam, nulla rerum.
                                            </p>
                                            <p class="text">
                                                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Praesentium deserunt est nihil molestiae, sequi ex asperiores. Nisi vel vero iste quisquam, saepe delectus, quae neque minima optio ullam, nulla rerum.
                                            </p>
                                            <p class="text">
                                                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Praesentium deserunt est nihil molestiae, sequi ex asperiores. Nisi vel vero iste quisquam, saepe delectus, quae neque minima optio ullam, nulla rerum.
                                            </p>
                                            <p class="text">
                                                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Praesentium deserunt est nihil molestiae, sequi ex asperiores. Nisi vel vero iste quisquam, saepe delectus, quae neque minima optio ullam, nulla rerum.
                                            </p>
                                            <p class="text">
                                                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Praesentium deserunt est nihil molestiae, sequi ex asperiores. Nisi vel vero iste quisquam, saepe delectus, quae neque minima optio ullam, nulla rerum.
                                            </p>
                                        </div>
                                        <form @submit.prevent="handleActivation()">
                                            <!-- <input type="hidden" v-model="trans.transaction_id" class="form-control" readonly> -->
                                            <div class="form-check my-2">
                                                <input class="form-check-input" type="checkbox" v-model="checked" value="" id="agree">
                                                <label class="form-check-label fw-bold" for="agree">
                                                    I agree to the Terms and Conditions
                                                </label>
                                            </div>
                                            <!-- <div id="feedback"></div> -->
                                            <div class="row">
                                                <div class="col-lg-8 mx-auto">
                                                    <div class="text-center button d-flex align-items-center justify-content-center">
                                                        <button type="button" class="btn btn_grey m-2" data-dismiss="modal">Back</button>
                                                        <button type="submit" class="btn btn_red" :disabled="!checked || loading">
                                                            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                                            <span v-show="!loading">Agree</span>
                                                        </button>
                                                        <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                                                        <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import { dragscroll } from "vue-dragscroll";
import axios from 'axios'
import $ from 'jquery'

// import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'

export default {
    name: 'Payment',
    directives: {
        dragscroll,
        // swiper: directive
    },
    components: {
        DashHeader,
        Sidebar,
        // Swiper,
        // SwiperSlide
    },
    data() {
        return {
            transaction: [],
            broker: [],
            brokerName: '',
            success: '',
            error: '',
            checked : false,
            loading : false,
            trans: {
                transaction_id: this.$route.params.id
            },
            // swiperOptions: {
            //     effect: 'coverflow',
            //     slidesPerView: 1.2,
            //     spaceBetween: 10,
            //     centeredSlides: true,
            //     pagination: {
            //         el: '.swiper-pagination',
            //         clickable: true
            //     },
            //     coverflowEffect: {
            //         rotate: 50,
            //         stretch: 0,
            //         depth: 100,
            //         modifier: 1,
            //         slideShadows : true
            //     },
            // }
        }
    },
    computed: {
        // swiper() {
        //     return this.$refs.mySwiper.$swiper
        // }
        // filterBroker(){
        //     return this.broker.filter(b => b.)
        // }
    },
    async mounted(){
        window.scrollTo(0,0)

        $(document).ready( function() {
            $('#agree').attr('disabled', 'disabled');

            $('#box-agree').scroll(function(){
                var agree_height = $(this)[0].scrollHeight;
                var scroll_height = agree_height - $(this).innerHeight();
                var scroll_top = $(this).scrollTop();

                // $('#feedback').text(scroll_height);

                if (scroll_top == scroll_height) {
                    $('#agree').removeAttr('disabled');
                } else{
                    $('#agree').attr('disabled', 'disabled');
                }
            });
        });
        
        await axios.get(`transaction/${this.$route.params.id}/`)
        .then(response => {
            // console.log('Transaction: ', response.data.data)
            this.transaction = response.data.data
        }).catch(() => {
            // console.log('Error Transaction: ', err.response)
        })
        await axios.get(`broker/`)
        .then(response => {
            // console.log('Broker All: ', response.data.data)
            this.broker = response.data.data

            for (let i = 0; i < this.broker.length; i++) {
                if (this.transaction.broker_account_id == this.broker[i].id) {
                    // console.log('broker Detail: ', this.broker[i])
                    this.brokerName = this.broker[i].name
                }
            }
        }).catch(() => {
            // console.log('Error Broker All: ', err.response)
        })
    },
    methods: {
        handleActivation(){
            this.loading = true
            let data = new FormData()
            data.append('transaction_id', this.trans.transaction_id)
            // data.append('broker_account_id', this.broker.id)

            axios.post(`transaction/confirm-fundmanager/`, data)
            .then((response) => {
                // console.log(response);
                this.success = response.data.message
                this.loading = true
                setTimeout(() => {
                    $('#agreement').modal('hide')
                    this.$router.push(`/subscriptions`)
                }, 3000)
            }).catch((err) => {
                this.error = err.response.data
                // console.log(err.response);
                this.loading = false
            })
        },
    }
}
</script>

<style>
.swiper{
    overflow-x: hidden;
    width: 100%;
}
/* .payment .card.card_payment{
    background: none !important;
    box-shadow: none;
} */
.card_payment .depo{
    color: var(--grey);
    font-weight: 600;
}
.payment_title{
    color: var(--grey);
    font-weight: 600;
}
.card_payment .money{
    color: var(--red);
    font-weight: 700;
    font-size: 28pt;
}

.modal_agree .box-agree{
    border: 1px solid #cfcfcf;
    padding: 10px;
    height: 200px;
    overflow-y: scroll;
}

.card_item .card-header{
    padding-bottom: 0 !important;
    /* border-bottom: 1px solid red !important; */
}
.card_item .card-header h5{
    font-weight: 700;
    color: var(--grey);
}
.card_item .item_image{
    width: 100%;
    height: 140px;
}
.card_item .item_image img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 5px;
}
.card_item .item_name{
    font-weight: 700;
}
.card_item .item_title{
    font-weight: 600;
    font-size: 10pt;
    margin: 0;
}
.card_item .item_value .badge{
    text-transform: uppercase;
    font-size: 10pt;
}
.card_item .item_value{
    font-size: 12pt;
}
.card_item .item_price{
    color: var(--red);
    font-weight: 700;
    font-size: 18pt;
}

.payment_card_container{
    margin: 20px 0;
    width: 100%;
    overflow: hidden;
    /* height: 280px; */
}
.card_group input.radio{
    display: none;
}
.card_group .bank_card{
    background: url('../assets/image/bank_card_bg_w.png') no-repeat, linear-gradient(-90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.2) 100%) !important;
    color: var(--dark-grey);
    background-size: cover !important;
    background-position: center;
    box-shadow: 5px 5px 20px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
}

.card_group .bank_card .card-body .chip svg path,
.card_group .bank_card .card-body .branch_name svg circle{
    fill: #000;
}
.card_group .bank_card .card-header{
    margin: 0;
    padding-bottom: 0;
    /* border-bottom: 1px solid red; */
}
.card_group .bank_card .card-body .chip{
    margin: 0 0 10px;
}
.card_group .bank_card .card-body .acc_number{
    font-size: 8pt;
    margin: 0;
    font-weight: 500;
}
.card_group .bank_card .card-body .number{
    /* font-size: 10pt; */
    margin: 0;
    /* letter-spacing: 1px; */
    font-weight: 600;
}
.card_group .bank_card .card-body .branch_name{
    display: flex;
    align-items: bottom;
    justify-content: space-between;
    margin: 10px 0 0;
}
.card_group .bank_card .card-body .branch_name p{
    margin: 10px 0 0;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 10pt;
}
.card_group input:checked ~ label{
    background: url('../assets/image/bank_card_bg.png') no-repeat, linear-gradient(90deg, rgba(22,22,22,1) 0%, rgba(65,65,65,1) 100%) !important;
    color: white;
    background-size: cover !important;
    background-position: center;
}
.card_group input:checked ~ .bank_card .card-body .chip svg path,
.card_group input:checked ~ .bank_card .card-body .branch_name svg circle{
    fill: #fff;
}

.button .btn_red{
    width: 100%;
    padding: 15px !important;
    text-transform: uppercase;
    font-size: 10pt;
}
.button .btn_red svg{
    margin-right: 4px;
}

.card_history .card-header{
    padding-bottom: 0 !important;
    border-bottom: 1px solid var(--light-grey) !important;
}
.card_history .card-header h5{
    font-weight: 700;
    color: var(--grey);
}

.card_history .history_group{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--light-grey);
}
.card_history .history_group .history_text .name{
    font-weight: 700;
    font-size: 12pt;
    margin: 0;
}
.card_history .history_group .history_text .text{
    font-weight: 400;
    font-size: 10pt;
}
.card_history .history_group .history_text .time{
    font-weight: 400;
    font-size: 10pt;
    color: var(--grey);
    display: flex;
    align-items: center;
}
.card_history .history_group .history_text .time svg{
    margin-right: 5px;
}

.card_history .history_group .history_price svg{
    margin-right: 5px;
}
.card_history .history_group .history_price .money{
    color: var(--red);
    font-weight: 600;
    font-size: 12pt;
}
</style>